import React, { useMemo, useState } from "react";
import { MoneyExAds } from "../../../pages";
import { MoneyExController } from "../../../controllers";

const MoneyExAdsContainer = () => {
  const [viewMoreAdsModal, setViewMoreAdsModal] = useState(false);
  const [createAdsModal, setCreateAdsModal] = useState(false);
  const [editAdsModal, setEditAdsModal] = useState(false);
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const moneyExAdsTableQuery = useMemo(() => {
    const query = `offset=${currentPage + 1}&limit=${limit}`;
    return query;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } = MoneyExController.useGetMoneyExAds(
    moneyExAdsTableQuery,
    filterQuery,
    searchQuery
  );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const goToCreateAdsModal = () => {
    setCreateAdsModal(true);
  };
  const goToEditAdsModal = () => {
    setEditAdsModal(true);
  };
  const closeModal = () => {
    setViewMoreAdsModal(false);
    setCreateAdsModal(false);
    setEditAdsModal(false);
  };

  const filterHandler = (query) => {
    setFilterQuery(query);
  };

  return (
    <MoneyExAds
      onLimitChange={onLimitChange}
      data={data}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      limit={limit}
      isLoading={isLoading}
      isFetching={isFetching}
      setSearchQuery={setSearchQuery}
      viewMoreAdsModal={viewMoreAdsModal}
      setViewMoreAdsModal={setViewMoreAdsModal}
      closeModal={closeModal}
      goToCreateAdsModal={goToCreateAdsModal}
      createAdsModal={createAdsModal}
      goToEditAdsModal={goToEditAdsModal}
      editAdsModal={editAdsModal}
      filterHandler={filterHandler}
    />
  );
};

export default MoneyExAdsContainer;
